import {api} from '@/api/factory';

class Serie {
    constructor() {}

    remove(serial_id:number | string) {
        return api.delete(`/v1/content-manager/series/${serial_id}`)
    }

    removeEpisode(serial_id, season_id, episode_id) {
        return api({
            url: `/v1/content-manager/series/${serial_id}/seasons/${season_id}/episodes/${episode_id}`,
            method: 'DELETE'
        })
    }

    create(serial) {
        return api({
            url: "/v1/content-manager/series",
            method: "POST",
            data: serial
        })
    }

    edit(serial_id, serial) {
        return api({
            url: `/v1/content-manager/series/${serial_id}`,
            method: "PUT",
            data: serial
        })
    }

    editSerie(serial_id, season_id, episode_id, data) {
        return api({
            url: `/v1/content-manager/series/${serial_id}/seasons/${season_id}/episodes/${episode_id}`,
            method: 'PUT',
            data: data
        })
    }

    addFileToSerie(serial_id, season_id, episode_id, item) {
        return api({
            url: `/v1/content-manager/series/${serial_id}/seasons/${season_id}/episodes/${episode_id}/voiceovers`,
            method: 'POST',
            data: item
        })
    }

    removeFileFromSerie(serial_id, season_id, episode_id, voiceover_id, video_id) {
        return api({
            url: `/v1/content-manager/series/${serial_id}/seasons/${season_id}/episodes/${episode_id}/voiceovers/${voiceover_id}/${video_id}`,
            method: 'DELETE'
        })
    }

    // Получение списка эпизодов сезона
    getListEpisodes(serial_id, season_id) {
        return ({
            method: 'GET',
            url: `v1/content-manager/series/${serial_id}/seasons/${season_id}/episodes`
        })
    }

    get(serial_id) {
        return api.get(`/v1/content-manager/series/${serial_id}`)
    }

    addSerieToSeason(serial_id, season_id, data) {
        return api({
            url: `/v1/content-manager/series/${serial_id}/seasons/${season_id}/episodes`,
            method: 'POST',
            data: data
        })
    }

    addVoiceover(serial_id, season_id, data, episode_id) {
        return api({
            url: `/v1/content-manager/series/${serial_id}/seasons/${season_id}/episodes/${episode_id}/voiceovers`,
            method: 'POST',
            data: data
        })
    }

    saveOrder(serial_id, season_id, data) {
        return api({
            url: `/v1/content-manager/series/${serial_id}/seasons/${season_id}/episodes/order`,
            method: 'PUT',
            data: {
                episodes: data
            }
        })
    }

    updateVoiceover(serial_id, season_id, episode_id, data, voiceover_id, video_id) {
        return api({
            url: `/v1/content-manager/series/${serial_id}/seasons/${season_id}/episodes/${episode_id}/voiceovers/${voiceover_id}/${video_id}`,
            method: 'PUT',
            data: data
        })
    }

    updateVoiceoversOrder(serial_id: number | string, season_id: number | string, episode_id: number | string, order: Array<{ video_id: number; sort_order: number }>) {
        return api({
            url: `/v1/content-manager/series/${serial_id}/seasons/${season_id}/episodes/${episode_id}/voiceovers/order`,
            method: 'PUT',
            data: { voiceovers: order }
        })
    }
}

export default Serie